// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__qu6Y8","toggleActive":"Toggle_toggleActive__Qiqno"};